<template>
    <div class="pa-4">
        <v-data-table
            :headers="headers"
            :items="items"
            class="elevation-1"
            :search="search">
            <template v-slot:top>
                <v-toolbar flat>
                    <v-toolbar-title>Outlet Categories</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details />
                    <v-spacer />
                    <v-dialog v-model="dialog" scrollable max-width="90%">
                        <template v-slot:activator="{ on, attrs}" v-if="$store.state.currentPagePriv.create">
                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                New Outlet Category
                            </v-btn>
                        </template>
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">{{ formTitle }}</span>
                            </v-card-title>
                            <v-divider />
                            <v-card-text>
                                <v-container fluid>
                                    <v-row align="center" justify="center" class="pa-10" v-if="onProgress">
                                        <v-progress-circular
                                                indeterminate
                                                color="primary"
                                                :size="70"
                                                :width="5"
                                            ></v-progress-circular>
                                    </v-row>
                                    <v-form ref="form" v-model="valid" lazy-validation v-if="!onProgress">
                                        <v-row>
                                            <v-col cols="6" sm="6" md="3">
                                                <span>Code</span>
                                                <v-text-field maxlength="10" v-model="editedItem.code" filled rounded dense hide-details="auto" @keydown.space.prevent :readonly="editedIndex > -1" :rules="reqRule"> </v-text-field>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="3">
                                                <span>Name</span>
                                                <v-text-field v-model="editedItem.name" filled rounded dense hide-details="auto" :rules="reqRule"></v-text-field>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="3">
                                                <span>Opening Hours</span>
                                                <v-select v-model="editedItem.operational_hour_start" :items="defaultTimes" filled rounded dense hide-details="auto" @change="selectedTimeStart" />
                                            </v-col>
                                            <v-col cols="6" sm="6" md="3">
                                                <span>Closing Hours</span>
                                                <v-select v-model="editedItem.operational_hour_end" :items="filteredDefaultEndTimes" filled rounded dense hide-details="auto" @change="selectedTimeEnd" />
                                            </v-col>
                                        </v-row>
                                        <v-row class="pa-0 mt-0 compact-form">
                                            <v-col cols="6" md="3" sm="6">
                                                <span>Choose Variant Bottle / Volume</span>
                                                <v-list class="d-flex pt-0 pb-4">
                                                    <v-list-item v-for="(botol, bidx) in botols" :key="bidx">
                                                        <v-checkbox hide-details :label="botol.description" :value="botol.code"
                                                            v-model="editedItem.botols" @change="handleVolumeChange"
                                                             />
                                                    </v-list-item>
                                                </v-list>
                                            </v-col>
                                        </v-row>
                                        <v-card outlined>
                                            <v-simple-table class="spreadsheet-table small-table flex-table" fixed-header>
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="header-cell text-center">Hari</th>
                                                            <th class="header-cell text-center">Min Stock</th>
                                                            <th class="header-cell text-center">Max Stock</th>
                                                            <th v-for="defaultTime in filteredDefaultTimes" :key="defaultTime.id" class="header-cell text-center">
                                                                {{ defaultTime.text }}
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(row, idt) in editedItem.weekdays_hours_percent" :key="idt">
                                                            <td class="header-cell">{{ defaultDays[idt].value }}</td>
                                                            <td class="spreadsheet-cell">
                                                                <v-text-field class="" v-model="row.min_stock" type="number" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                            </td>
                                                            <td class="spreadsheet-cell">
                                                                <v-text-field class="" v-model="row.max_stock" type="number" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                            </td>
                                                            <td class="spreadsheet-cell" v-for="(item, idx) in row.times" :key="idx" v-show="idx >= indexTimeStart && idx <= indexTimeEnd">
                                                                <v-text-field class="" v-model="row.times[idx]" type="number" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-card>
                                        <v-card outlined class="mt-4">
                                            <v-card-title class="py-2">Default PPIC</v-card-title>
                                            <v-row class="compact-form pa-3 pt-0 mt-0">
                                                <v-col cols="3" md="3" sm="6">
                                                    <v-select outlined dense hide-details="auto" :items="editedItem.botols" v-model="selectedBottle" @change="changeSelectedBottle">
                                                    </v-select>
                                                </v-col>
                                            </v-row>
                                            <v-simple-table class="spreadsheet-table small-table flex-table" fixed-header id="productTbl">
                                                <template v-slot:default>
                                                    <thead>
                                                        <tr>
                                                            <th class="header-cell" colspan="2"></th>
                                                            <th class="header-cell text-center">Minggu</th>
                                                            <th class="header-cell text-center">Senin</th>
                                                            <th class="header-cell text-center">Selasa</th>
                                                            <th class="header-cell text-center">Rabu</th>
                                                            <th class="header-cell text-center">Kamis</th>
                                                            <th class="header-cell text-center">Jumat</th>
                                                            <th class="header-cell text-center">Sabtu</th>
                                                        </tr>
                                                        <tr>
                                                            <th class="header-cell" colspan="2">Target Sales</th>
                                                            <td class="spreadsheet-cell" v-for="(target, i)  in selectedTargets.days" :key="i">
                                                                <v-text-field type="number" v-model="selectedTargets.days[i]" solo hide-details @wheel="$event.target.blur()" min="0" />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th class="header-cell">Kode</th>
                                                            <th class="header-cell">Produk</th>
                                                            <th class="header-cell text-center">Minggu (%)</th>
                                                            <th class="header-cell text-center">Senin (%)</th>
                                                            <th class="header-cell text-center">Selasa (%)</th>
                                                            <th class="header-cell text-center">Rabu (%)</th>
                                                            <th class="header-cell text-center">Kamis (%)</th>
                                                            <th class="header-cell text-center">Jumat (%)</th>
                                                            <th class="header-cell text-center">Sabtu (%)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(product, idxp) in filteredProducts" :key="idxp">
                                                            <td class="header-cell">{{ idxp + 1 }}. {{ product.code }}</td>
                                                            <td class="header-cell">{{ product.name }}</td>
                                                            <td class="spreadsheet-cell"><v-text-field type="number" v-model="product.target_sun" solo hide-details @wheel="$event.target.blur()" min="0" /></td>
                                                            <td class="spreadsheet-cell"><v-text-field type="number" v-model="product.target_mon" solo hide-details @wheel="$event.target.blur()" min="0" /></td>
                                                            <td class="spreadsheet-cell"><v-text-field type="number" v-model="product.target_tue" solo hide-details @wheel="$event.target.blur()" min="0" /></td>
                                                            <td class="spreadsheet-cell"><v-text-field type="number" v-model="product.target_wed" solo hide-details @wheel="$event.target.blur()" min="0" /></td>
                                                            <td class="spreadsheet-cell"><v-text-field type="number" v-model="product.target_thu" solo hide-details @wheel="$event.target.blur()" min="0" /></td>
                                                            <td class="spreadsheet-cell"><v-text-field type="number" v-model="product.target_fri" solo hide-details @wheel="$event.target.blur()" min="0" /></td>
                                                            <td class="spreadsheet-cell"><v-text-field type="number" v-model="product.target_sat" solo hide-details @wheel="$event.target.blur()" min="0" /></td>
                                                        </tr>
                                                        <tr>
                                                            <td class="header-cell"></td>
                                                            <td class="header-cell">Total</td>
                                                            <td class="header-cell text-center">{{ totalSalesTargetSun }}</td>
                                                            <td class="header-cell text-center">{{ totalSalesTargetMon }}</td>
                                                            <td class="header-cell text-center">{{ totalSalesTargetTue }}</td>
                                                            <td class="header-cell text-center">{{ totalSalesTargetWed }}</td>
                                                            <td class="header-cell text-center">{{ totalSalesTargetThu }}</td>
                                                            <td class="header-cell text-center">{{ totalSalesTargetFri }}</td>
                                                            <td class="header-cell text-center">{{ totalSalesTargetSat }}</td>
                                                        </tr>
                                                    </tbody>
                                                </template>
                                            </v-simple-table>
                                        </v-card>
                                    </v-form>
                                </v-container>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="close" :disabled="onProgress">
                                    Cancel
                                </v-btn>
                                <v-btn color="blue darken-1" text @click="save" :disabled="onProgress">
                                    Save
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDelete" persistent max-width="500px">
                        <v-card>
                            <v-card-title class="text-h5">Konfirmasi</v-card-title>
                            <v-card-text>Anda akan menghapus kategori outlet ini ?</v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="grey" text @click="closeDelete">Cancel</v-btn>
                                <v-btn color="red" text @click="deleteItemConfirm">Delete</v-btn>
                                <v-spacer />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogProductWarning" max-width="500px">
                        <v-card>
                            <v-card-title class="body-1 text-center">Produk yang Anda pilih sudah ada.</v-card-title>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="dialogProductWarning = false">OK</v-btn>
                                <v-spacer />
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogDetail" scrollable max-width="90%">
                        <v-card>
                            <v-card-title>
                                <span class="text-h5">Detail Outlet Category</span>
                            </v-card-title>
                            <v-divider />
                            <v-card-text>
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="6" sm="6" md="3">
                                            <span>Code</span>
                                            <v-text-field v-model="viewedItem.code" filled rounded dense hide-details="auto" readonly> </v-text-field>
                                        </v-col>
                                        <v-col cols="6" sm="6" md="3">
                                            <span>Name</span>
                                            <v-text-field v-model="viewedItem.name" filled rounded dense hide-details="auto" readonly></v-text-field>
                                        </v-col>
                                        <v-col cols="6" sm="6" md="3">
                                            <span>Opening Hours</span>
                                            <v-text-field v-model="viewedItem.operational_hour_start" filled rounded dense hide-details="auto" readonly />
                                        </v-col>
                                        <v-col cols="6" sm="6" md="3">
                                            <span>Closing Hours</span>
                                            <v-text-field v-model="viewedItem.operational_hour_end" filled rounded dense hide-details="auto" readonly />
                                        </v-col>
                                    </v-row>
                                    <v-row class="pa-0 mt-0 compact-form">
                                        <v-col cols="12" md="12" sm="12">
                                            <span>Variant Bottle / Volume</span>
                                            <v-chip-group>
                                                <v-chip v-for="(botol, bidx) in sortedViewedBotols" :key="bidx" color="primary" outlined>
                                                    {{ getBotolDescription(botol) }}
                                                </v-chip>
                                            </v-chip-group>
                                        </v-col>
                                    </v-row>
                                    <v-card outlined class="mt-2">
                                        <v-card-title class="py-2">Hourly Percentage</v-card-title>
                                        <v-simple-table class="spreadsheet-table small-table flex-table" fixed-header>
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th class="header-cell text-center">Hari</th>
                                                        <th class="header-cell text-center">Min Stock</th>
                                                        <th class="header-cell text-center">Max Stock</th>
                                                        <th v-for="defaultTime in filteredViewedTimes" :key="defaultTime.id" class="header-cell text-center">
                                                            {{ defaultTime.text }}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(row, idt) in viewedItem.weekdays_hours_percent" :key="idt">
                                                        <td class="header-cell">{{ defaultDays[idt].value }}</td>
                                                        <td class="text-center">{{ row.min_stock }}</td>
                                                        <td class="text-center">{{ row.max_stock }}</td>
                                                        <td class="text-center" v-for="(item, idx) in row.times" :key="idx" v-show="idx >= viewIndexTimeStart && idx <= viewIndexTimeEnd">
                                                            {{ row.times[idx] }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card>
                                    <v-card outlined class="mt-4">
                                        <v-card-title class="py-2">Default PPIC</v-card-title>
                                        <v-tabs v-model="selectedViewTab" background-color="transparent" color="primary">
                                            <v-tab v-for="(botol, bidx) in sortedViewedBotols" :key="bidx">
                                                {{ botol }}
                                            </v-tab>
                                        </v-tabs>
                                        <v-tabs-items v-model="selectedViewTab">
                                            <v-tab-item v-for="(botol, bidx) in sortedViewedBotols" :key="bidx">
                                                <v-simple-table class="spreadsheet-table small-table flex-table" fixed-header>
                                                    <template v-slot:default>
                                                        <thead>
                                                            <tr>
                                                                <th class="header-cell" colspan="2"></th>
                                                                <th class="header-cell text-center">Minggu</th>
                                                                <th class="header-cell text-center">Senin</th>
                                                                <th class="header-cell text-center">Selasa</th>
                                                                <th class="header-cell text-center">Rabu</th>
                                                                <th class="header-cell text-center">Kamis</th>
                                                                <th class="header-cell text-center">Jumat</th>
                                                                <th class="header-cell text-center">Sabtu</th>
                                                            </tr>
                                                            <tr>
                                                                <th class="header-cell" colspan="2">Target Sales</th>
                                                                <td class="text-center" v-for="(target, i) in getViewedTargets(botol).days" :key="i">
                                                                    {{ target }}
                                                                </td>
                                                            </tr>
                                                            <tr>
                                                                <th class="header-cell">Kode</th>
                                                                <th class="header-cell">Produk</th>
                                                                <th class="header-cell text-center">Minggu (%)</th>
                                                                <th class="header-cell text-center">Senin (%)</th>
                                                                <th class="header-cell text-center">Selasa (%)</th>
                                                                <th class="header-cell text-center">Rabu (%)</th>
                                                                <th class="header-cell text-center">Kamis (%)</th>
                                                                <th class="header-cell text-center">Jumat (%)</th>
                                                                <th class="header-cell text-center">Sabtu (%)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(product, idxp) in getViewedProducts(botol)" :key="idxp">
                                                                <td class="header-cell">{{ idxp + 1 }}. {{ product.code }}</td>
                                                                <td class="header-cell">{{ product.name }}</td>
                                                                <td class="text-center">{{ product.target_sun }}</td>
                                                                <td class="text-center">{{ product.target_mon }}</td>
                                                                <td class="text-center">{{ product.target_tue }}</td>
                                                                <td class="text-center">{{ product.target_wed }}</td>
                                                                <td class="text-center">{{ product.target_thu }}</td>
                                                                <td class="text-center">{{ product.target_fri }}</td>
                                                                <td class="text-center">{{ product.target_sat }}</td>
                                                            </tr>
                                                            <tr>
                                                                <td class="header-cell"></td>
                                                                <td class="header-cell"><strong>Total</strong></td>
                                                                <td class="header-cell text-center"><strong>{{ getViewedTotalSun(botol) }}</strong></td>
                                                                <td class="header-cell text-center"><strong>{{ getViewedTotalMon(botol) }}</strong></td>
                                                                <td class="header-cell text-center"><strong>{{ getViewedTotalTue(botol) }}</strong></td>
                                                                <td class="header-cell text-center"><strong>{{ getViewedTotalWed(botol) }}</strong></td>
                                                                <td class="header-cell text-center"><strong>{{ getViewedTotalThu(botol) }}</strong></td>
                                                                <td class="header-cell text-center"><strong>{{ getViewedTotalFri(botol) }}</strong></td>
                                                                <td class="header-cell text-center"><strong>{{ getViewedTotalSat(botol) }}</strong></td>
                                                            </tr>
                                                        </tbody>
                                                    </template>
                                                </v-simple-table>
                                            </v-tab-item>
                                        </v-tabs-items>
                                    </v-card>
                                </v-container>
                            </v-card-text>
                            <v-divider />
                            <v-card-actions>
                                <v-spacer />
                                <v-btn color="blue darken-1" text @click="closeDetail">
                                    Close
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>
            </template>
            <template v-slot:[`item.jam_operasional`]="{ item }">
                {{ item.operational_hour_start }} - {{ item.operational_hour_end }}
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <v-icon small class="mr-2" @click="viewDetail(item)">
                    mdi-eye
                </v-icon>
                <v-icon small class="mr-2" @click="editItem(item)" v-if="$store.state.currentPagePriv.update">
                    mdi-pencil
                </v-icon> 
                <v-icon small @click="deleteItem(item)" v-if="$store.state.currentPagePriv.delete">
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">
                    Reset
                </v-btn>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    export default {
        data: () => ({
            onProgress: false,
            activePicker: 'minute',
            dialog: false,
            dialogDelete: false,
            dialogProductWarning: false,
            dialogDetail: false,
            headers: [
                { text: 'Code', value: 'code' },
                { text: 'Outlet Category Name', value: 'name' },
                { text: 'Operating Hours', value: 'jam_operasional', sortable: false },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            items: [],
            products: [],
            editedIndex: -1,
            viewedItem: {
                code: '',
                name: '',
                operational_hour_start: '',
                operational_hour_end: '',
                weekdays_hours_percent: [],
                botols: [],
                targets: [],
                products: [],
            },
            viewIndexTimeStart: 0,
            viewIndexTimeEnd: 23,
            selectedViewTab: 0,
            editedItem: {
                code: '',
                name: '',
                operational_hour_start: '',
                operational_hour_end: '',
                weekdays_hours_percent: [],
                weekend_hours_percent: [],
                botols: [],
                targets: [],
                products: [],
            },
            defaultItem: {
                code: '',
                name: '',
                operational_hour_start: '',
                operational_hour_end: '',
                weekdays_hours_percent: [],
                weekend_hours_percent: [],
                botols: [],
                targets: [],
                products: [],
            },
            search: '',
            reqRule: [v => !!v || 'Harus diisi!'],
            numberRule: val => {
                return parseInt(val) < 0 ? 'Tidak boleh kurang dari 0' : '';
            },
            valid: true,
            defaultTimes: [],
            indexTimeStart: 0,
            indexTimeEnd: 23,
            selectedBottle: '',
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'New Outlet Category' : 'Edit Outlet Category'
            },
            filteredWeekdaysHoursPercent() {
                return this.editedItem.weekdays_hours_percent.filter((item, index) => {
                    return index >= this.indexTimeStart && index <= this.indexTimeEnd 
                })
            },
            filteredWeekendHoursPercent() {
                return this.editedItem.weekend_hours_percent.filter((item, index) => {
                    return index >= this.indexTimeStart && index <= this.indexTimeEnd 
                })
            },
            filteredViewedTimes() {
                return this.defaultTimes.filter((item, index) => {
                    return index >= this.viewIndexTimeStart && index <= this.viewIndexTimeEnd 
                })
            },
            filteredDefaultTimes() {
                return this.defaultTimes.filter((item, index) => {
                    return index >= this.indexTimeStart && index <= this.indexTimeEnd 
                })
            },
            filteredDefaultEndTimes() {
                return this.defaultTimes.filter((item, index) => {
                    return index > this.indexTimeStart
                })
            },
            botols() {
                let dataMiscCodes = this.$store.state.misccode.objs
                    return dataMiscCodes.filter((i => i.type.includes('Botol')))
                        .sort((a,b) => {
                            return parseInt(a.code) - parseInt(b.code)
                        })
            },
            defaultDays() {
                return this.$store.state.outlet.default_days;
            },
            selectedTargets() {
                const selectedTarget = this.editedItem.targets.find((i) => i.size === this.selectedBottle);

                if (selectedTarget) {
                    return selectedTarget;
                } else {
                    return {
                        'size': '',
                        'days': [0,0,0,0,0,0,0]
                    };
                }
            },
            filteredProducts() {
                return this.editedItem.products.filter(p => p.size == this.selectedBottle && p.is_active == true)
                    .sort((a, b) => a.sort_no - b.sort_no);
            },
            totalSalesTargetSun() {
                return this.filteredProducts.reduce((total, item) => total + Number(item.target_sun), 0);
            },
            totalSalesTargetMon() {
                return this.filteredProducts.reduce((total, item) => total + Number(item.target_mon), 0);
            },
            totalSalesTargetTue() {
                return this.filteredProducts.reduce((total, item) => total + Number(item.target_tue), 0);
            },
            totalSalesTargetWed() {
                return this.filteredProducts.reduce((total, item) => total + Number(item.target_wed), 0);
            },
            totalSalesTargetThu() {
                return this.filteredProducts.reduce((total, item) => total + Number(item.target_thu), 0);
            },
            totalSalesTargetFri() {
                return this.filteredProducts.reduce((total, item) => total + Number(item.target_fri), 0);
            },
            totalSalesTargetSat() {
                return this.filteredProducts.reduce((total, item) => total + Number(item.target_sat), 0);
            },
            sortedViewedBotols() {
                // Sort bottles di detail view supaya urutannya sama dengan edit view
                if (!this.viewedItem.botols || this.viewedItem.botols.length === 0) {
                    return [];
                }
                
                return [...this.viewedItem.botols].sort((a, b) => {
                    return parseInt(a) - parseInt(b);
                });
            }
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
            dialogDelete (val) {
                val || this.closeDelete()
            },
            dialogDetail (val) {
                val || this.closeDetail()
            },
            dialogJamMulai(val) {
                if (val) {
                    this.activePicker = 'hour'
                }
            }
        },

        created () {
            this.getDataProducts();
            this.generateDefaultTime();
            this.initialize();
        },

        methods: {
            selectedTimeStart() {
                this.indexTimeStart = this.defaultTimes.findIndex(item => item.text == this.editedItem.operational_hour_start)
            },
            selectedTimeEnd() {
                this.indexTimeEnd = this.defaultTimes.findIndex(item => item.text == this.editedItem.operational_hour_end)
            },
            generateDefaultTargets() {
                let dataBotol = this.editedItem.botols;
                this.editedItem.targets = [];
                dataBotol.forEach((item) => {
                    this.editedItem.targets.push({
                        'size': item,
                        'days': [0,0,0,0,0,0,0]
                    })
                })
            },
            handleVolumeChange() {
                this.editedItem.botols.forEach((item) => {
                    const findTarget = this.editedItem.targets.find((i) => i.size === item);
                    if (!findTarget) {
                        this.editedItem.targets.push({
                            'size': item,
                            'days': [0,0,0,0,0,0,0]
                        })
                    }
                });

                this.editedItem.targets = this.editedItem.targets.filter(target => this.editedItem.botols.some(botol => botol === target.size));
            },
            changeSelectedBottle(value) {
                const products = this.products.filter((p) => p.size === value && p.is_active == 1);
                products.forEach((product) => {
                    const findProduct = this.editedItem.products.find((p) => p.code == product.code);
                    if (!findProduct) {
                        this.editedItem.products.push({
                            code: product.code,
                            name: product.name,
                            size: product.size,
                            is_active: product.is_active,
                            target_mon: 0,
                            target_tue: 0,
                            target_wed: 0,
                            target_thu: 0,
                            target_fri: 0,
                            target_sat: 0,
                            target_sun: 0,
                        });
                    }
                });
            },
            generateDefaultTime() {
                this.defaultTimes = []
                this.editedItem.weekdays_hours_percent = []

                for (let i = 0; i < 24; i++) {
                    
                    this.defaultTimes.push({
                        id: i,
                        text: i > 9 ? `${i}:00` : `0${i}:00`
                    });
                }

                for (let i = 0; i < 7; i++) {
                    let obj = [];
                    for (let j = 0; j < 24; j++) {
                        obj.push(0);
                    }
                    this.editedItem.weekdays_hours_percent.push({
                        'min_stock': 0,
                        'max_stock': 0,
                        'times': obj
                    });
                }
            },
            viewDetail(item) {
                this.viewedItem = Object.assign({}, item)
                this.viewIndexTimeStart = this.defaultTimes.findIndex(i => i.text == this.viewedItem.operational_hour_start)
                this.viewIndexTimeEnd = this.defaultTimes.findIndex(i => i.text == this.viewedItem.operational_hour_end)
                this.selectedViewTab = 0
                this.dialogDetail = true
            },
            getBotolDescription(code) {
                const botol = this.botols.find(b => b.code === code)
                return botol ? botol.description : code
            },
            getViewedTargets(size) {
                const target = this.viewedItem.targets.find(t => t.size === size)
                return target || { size: '', days: [0,0,0,0,0,0,0] }
            },
            getViewedProducts(size) {
                return this.viewedItem.products.filter(p => p.size === size && p.is_active == true)
                    .sort((a, b) => a.sort_no - b.sort_no)
            },
            getViewedTotalSun(size) {
                return this.getViewedProducts(size).reduce((total, item) => total + Number(item.target_sun), 0)
            },
            getViewedTotalMon(size) {
                return this.getViewedProducts(size).reduce((total, item) => total + Number(item.target_mon), 0)
            },
            getViewedTotalTue(size) {
                return this.getViewedProducts(size).reduce((total, item) => total + Number(item.target_tue), 0)
            },
            getViewedTotalWed(size) {
                return this.getViewedProducts(size).reduce((total, item) => total + Number(item.target_wed), 0)
            },
            getViewedTotalThu(size) {
                return this.getViewedProducts(size).reduce((total, item) => total + Number(item.target_thu), 0)
            },
            getViewedTotalFri(size) {
                return this.getViewedProducts(size).reduce((total, item) => total + Number(item.target_fri), 0)
            },
            getViewedTotalSat(size) {
                return this.getViewedProducts(size).reduce((total, item) => total + Number(item.target_sat), 0)
            },
            closeDetail() {
                this.dialogDetail = false
                this.$nextTick(() => {
                    this.viewedItem = {
                        code: '',
                        name: '',
                        operational_hour_start: '',
                        operational_hour_end: '',
                        weekdays_hours_percent: [],
                        botols: [],
                        targets: [],
                        products: [],
                    }
                    this.viewIndexTimeStart = 0
                    this.viewIndexTimeEnd = 23
                    this.selectedViewTab = 0
                })
            },
            isInRange(index) {
                return index >= this.indexTimeStart && index <= this.indexTimeEnd
            },
            async initialize () {
                let response = await this.$store.dispatch('outletcategory/getObjs')
                if (response.data.status=='success') this.items = response.data.data
            },
            async getDataProducts() {
                let response = await this.$store.dispatch('variant/getObjs');
                if (response.data.status == 'success') {
                    this.products = response.data.data;
                }
            },
            async getDataBotol() {
                let response = await this.$store.dispatch('misccode/getObjs')
                if (response.data.status == 'success') {
                    let dataMisscode = response.data.data;
                    this.botols = dataMisscode.filter((i => i.type.includes('Botol')))
                }
            },
            editItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.indexTimeStart = this.defaultTimes.findIndex(i => i.text == this.editedItem.operational_hour_start)
                this.indexTimeEnd = this.defaultTimes.findIndex(i => i.text == this.editedItem.operational_hour_end)
                this.dialog = true
            },
            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },
            async deleteItemConfirm () {
                try {
                    const result = (await this.$store.dispatch('outletcategory/deleteObj', this.editedItem.code))
                    if (result.status == 'success') {
                        this.items.splice(this.editedIndex, 1)
                        this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data berhasil dihapus'})
                    } else {
                        this.$store.commit('setSnackbar', {saveError: true, errorMessage: result.message})
                    }
                } catch (error) {
                    console.log(error)
                    this.$store.commit('setSnackbar', {saveError: true, errorMessage: error.response.data.message})
                }

                this.closeDelete()
            },
            close () {
                
                this.dialog = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                    this.generateDefaultTime()
                    this.indexTimeStart = 0
                    this.indexTimeEnd = 23
                    this.resetValidation()
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },

            async save () {
                await this.$refs.form.validate();
                if (!this.valid) return;

                this.onProgress = true

                if (this.editedIndex > -1) {
                    let url = this.$store.state.config.apiHost + "outlet-categories/" + this.editedItem.code
                    let response = await this.$axios.put(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
                    if (response.data.status=='success') Object.assign(this.items[this.editedIndex], this.editedItem)
                    this.close()
                    this.onProgress = false
                    this.initialize();
                    this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data Kategori Outlet berhasil diupdate'})
                } else {
                    try {
                        let dataItem = Object.assign({}, this.editedItem)
                        let url = this.$store.state.config.apiHost + "outlet-categories"
                        let response = await this.$axios.post(url, JSON.stringify(this.editedItem), {headers:{'Authorization': 'Bearer '+ this.$store.state.token, 'Content-Type': 'application/json'}})
                        if (response.data.status=='success') this.items.push(dataItem)
                        this.close()
                        this.initialize();
                        this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data Kategori Outlet berhasil ditambahkan'})
                    }
                    catch (err) {
                        const keyword = 'duplicate key'
                        if (err.response.data.message.search(keyword) > -1){
                        return this.$store.commit('setSnackbar', {saveError: true, errorMessage: "Duplicate Key! Kode sudah terpakai."})
                        }
                        else {
                        return this.$store.commit('setSnackbar', {saveError: true, errorMessage: err.response.data.message})
                        }
                    } finally {
                        this.onProgress = false
                    }
                }
            },

            resetValidation() {
                this.$refs['form'].resetValidation();
            },
        },
    }
</script>

<style>
.v-text-field fieldset, .v-text-field .v-input__control, .v-text-field .v-input__slot {
    border-radius: 7px!important;
}

.custom-time-picker .v-time-picker-title {
  justify-content: center;
}
.custom-time-picker.use-hours-only .v-time-picker-title {
  pointer-events: none;
}
</style>